import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <MediaSection />
        <FeaturesSection />
        <TopicsSection />
        <CarouselSection />
        <FaqSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <AboutSection />
        <AppSection />
        <CommentsSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}